module.exports = __webpack_public_path__ + "static/media/FBO10.913673df.mp4";